const CHECK_EMITER_NFE_REFERENCES = "CHECK_EMITER_NFE_REFERENCES"
const ISSUE_OF_INVOICE_NFE = "ISSUE_OF_INVOICE_NFE"
const GET_SEQUENCE_NFE = "GET_SEQUENCE_NFE"
const REPRINT_NFE_WITH_KEY = "REPRINT_NFE_WITH_KEY"

module.exports = {
    CHECK_EMITER_NFE_REFERENCES,
    ISSUE_OF_INVOICE_NFE,
    GET_SEQUENCE_NFE,
    REPRINT_NFE_WITH_KEY,
}